import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import EfFaqCollapse from '@elem/ui/ef-faq-collapse';
import { theme } from '../../config';
import css from './index.module.scss';

interface ItfItem {
    title: string;
    desc: string;
    img: string;
    isVideo: boolean;
}
const B: React.FC = () => {
    const { t } = useLang('stream.overview');
    const video = 'https://websiteoss.ecoflow.com/upload/video/1775027395634/b1.mp4';
    const items: ItfItem[] = [
        {
            title: t('B_item1_name'),
            desc: t('B_item1_text'),
            img: video,
            isVideo: true,
        },
        {
            title: t('B_item2_name'),
            desc: t('B_item2_text'),
            img: video,
            isVideo: true,
        },
        {
            title: t('B_item3_name'),
            desc: t('B_item3_text'),
            img: video,
            isVideo: true,
        },
    ];

    useOnceInView('.stream-nl-B .title', () => {
        document.querySelector('.stream-nl-B .title')?.classList.add('enter');
        document.querySelector('.stream-nl-B .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-B .content')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-B GtmModuleData-section space box`} id="stream-nl-B" data-section-id={'stream-nl-B'}>
            <div className="info">
                <h2 className="title ani-1">{t('B_title')}</h2>
                <p className="desc ani-2">
                    {t.rich('B_desc', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </p>
            </div>
            <div className="content ani-3">
                <EfFaqCollapse type="img" lists={items} title="" theme={theme} />
            </div>
        </div>
    );
};

export default B;
